<template>
    <tr :class='priorityClass(value.priority)'>
        <td style='text-align: center'>
            <input :placeholder="this.$t('translations.min')" size='8' class='w-auto mr-1 ml-1' type="text" v-model='value.systolic_min'>
            &nbsp;to&nbsp;
            <input :placeholder="this.$t('translations.max')" size='8' class='w-auto mr-1 ml-1' type="text" v-model='value.systolic_max'>
        </td>
        <td style='text-align: center'>
            <label class='toggle-label-neutral'>
                <input v-model='value.relation_and' type='checkbox' />
                <span class='back'>
                    <span class='toggle'></span>
                    <span class='label off'>{{ $t('translations.relation_or')}}</span>
                    <span class='label on'>{{ $t('translations.relation_and')}}</span>
                </span>
            </label>
        </td>
        <td style='text-align: center'>
            <input :placeholder="this.$t('translations.min')" size='8' class='w-auto mr-1 ml-1' type="text" v-model='value.diastolic_min'>
            &nbsp;to&nbsp;
            <input :placeholder="this.$t('translations.max')" size='8' class='w-auto mr-1 ml-1' type="text" v-model='value.diastolic_max'>
        </td>
        <td style='text-align: center'>
            <priority-flags class="pl-1" elevated='translations.elevated' v-model='value.priority'></priority-flags>
        </td>
        <td class='bg-routine' style='text-align: center;'>
            <button class="btn btn-round btn-sm btn-danger" v-on:click='$parent.removeItem(index)'>{{ $t('translations.remove')}}</button>
        </td>
        <!-- <p class='small'>{{ verbal_range(value) }}</p> -->
    </tr>
</template>

<script>
export default {
    props: {
        value: {
        },
        editable: {
            default: true,
        },
        showdescription: {
            default: true,
        },
        index: {}
    },
    data() {
        return {
            resetCounter: 0,
            show_characters_left: false,
        };
    },
    computed: {
    },
    watch: {
        
    },
    mounted() {
        //console.info(this.value);
        if(!this.value.id) {
            Vue.set(this.value, 'systolic_min', '');
            Vue.set(this.value, 'diastolic_min', '');
            Vue.set(this.value, 'systolic_max', '');
            Vue.set(this.value, 'diastolic_max', '');
            Vue.set(this.value, 'relation_and', false);
            Vue.set(this.value, 'priority', 0);
            Vue.set(this.value, 'tag_id', null);
            Vue.set(this.value, 'user_id', null);
        }
    },
    methods: {
        clear() {
            this.value.systolic_min = "";
            this.value.diastolic_min = "";
            this.value.systolic_max = "";
            this.value.diastolic_max = "";
            this.value.relation_and = false;
            this.value.priority = 0;
            this.value.tag_id = null;
            this.value.user_id = null;
        },
        reset() {
            
        },
        verbal_range(range) {
            var content = "";
            if(parseInt(range.systolic_min) && parseInt(range.systolic_max)) {
                content = `Systolic pressure from ${range.systolic_min} to ${range.systolic_max}`;
                if(parseInt(range.diastolic_min) && parseInt(range.diastolic_max)) {
                    content += ` AND a simultaneous `;
                }
                else {
                    content += `, regardless of diastolic pressure`;
                }
            }
            if(parseInt(range.diastolic_min) && parseInt(range.diastolic_max)) {
                content += `Diastolic pressure from ${range.diastolic_min} to ${range.diastolic_max}`;
                if(parseInt(range.systolic_min) && parseInt(range.systolic_max)) {
                }
                else {
                    content += `, regardless of systolic pressure`;
                }
            }
            return content ? `Will flag when a blood pressure reading has a ${content}` : "";
        },
        priorityClass(priority) {
            switch(priority) {
                case -10: return "bg-lower"; break;
                case 5: return "bg-elevated"; break;
                case 10: return "bg-urgent"; break;
                case 20: return "bg-emergency"; break;
                default: return "bg-routine"; break;
            }
        },
    },
};
</script>
